/* ═══════════════════════════════════════════════════════
   Search Page JS — Smith's Blades
   Uses Predictive API + client-side mid-word matching.
   ═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ——— DOM REFS ——— */
  var searchPage        = document.querySelector('.search-page');
  var loadingWrap       = document.getElementById('searchPageLoading');

  var jsResults         = document.getElementById('searchJsResults');
  var jsMeta            = document.getElementById('searchJsMeta');
  var jsCount           = document.getElementById('searchJsCount');
  var jsCountLabel      = document.getElementById('searchJsCountLabel');
  var jsGrid            = document.getElementById('searchJsGrid');

  var collFallback      = document.getElementById('searchCollectionFallback');
  var collName          = document.getElementById('searchFallbackCollectionName');
  var collGrid          = document.getElementById('searchCollectionGrid');

  var suggestionsWrap   = document.getElementById('searchSuggestionsSection');
  var suggestionsGrid   = document.getElementById('searchSuggestionsGrid');

  var emptyWrap         = document.getElementById('searchPageEmpty');
  var emptyTerm         = document.getElementById('searchEmptyTerm');
  var errorWrap         = document.getElementById('searchPageError');

  /* ——— Only run on pages with NO Liquid results ——— */
  if (!searchPage || !loadingWrap) return;

  var searchTerm       = searchPage.getAttribute('data-search-term') || '';
  var perRow           = searchPage.getAttribute('data-per-row') || 4;
  var maxResults       = 48;
  var suggestionsCount = 8;
  var currentXHR       = null;

  /* ——— ALL PRODUCTS CACHE ——— */
  var allProductsCache = null;
  var cacheLoading     = false;
  var cacheCallbacks   = [];

  /* ═══════════════════════════════════════════════════
     HELPERS
     ═══════════════════════════════════════════════════ */
  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    var format = window.SmithsBlades && window.SmithsBlades.moneyFormat
      ? window.SmithsBlades.moneyFormat
      : '${{amount}}';
    var val = (cents / 100).toFixed(2);
    return format.replace('{{amount}}', val)
                 .replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }

  function esc(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;')
              .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function hideAll() {
    if (loadingWrap)     loadingWrap.style.display     = 'none';
    if (jsResults)       jsResults.style.display       = 'none';
    if (jsMeta)          jsMeta.style.display          = 'none';
    if (collFallback)    collFallback.style.display    = 'none';
    if (suggestionsWrap) suggestionsWrap.style.display = 'none';
    if (emptyWrap)       emptyWrap.style.display       = 'none';
    if (errorWrap)       errorWrap.style.display       = 'none';
  }

  /* ═══════════════════════════════════════════════════
     CLIENT-SIDE FUZZY MATCHING
     Matches query ANYWHERE in product fields
     ═══════════════════════════════════════════════════ */
  function productMatchesQuery(product, query) {
    var q = query.toLowerCase().trim();
    if (!q) return false;

    var searchableFields = [
      product.title        || '',
      product.vendor       || '',
      product.product_type || '',
      product.handle       || '',
      (product.tags || []).join(' '),
      (product.variants || []).map(function(v) {
        return (v.title || '') + ' ' + (v.sku || '');
      }).join(' ')
    ];

    var searchableText = searchableFields.join(' ').toLowerCase();

    /* Every word in query must appear somewhere */
    var words = q.split(/\s+/).filter(function(w) { return w.length > 0; });
    return words.every(function(word) {
      return searchableText.indexOf(word) !== -1;
    });
  }

  /* ═══════════════════════════════════════════════════
     ALL PRODUCTS CACHE
     ═══════════════════════════════════════════════════ */
  function getAllProducts(callback) {
    if (allProductsCache !== null) {
      callback(allProductsCache);
      return;
    }

    if (cacheLoading) {
      cacheCallbacks.push(callback);
      return;
    }

    cacheLoading = true;
    cacheCallbacks.push(callback);

    var url = '/collections/all/products.json?limit=250&sort_by=best-selling';
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.setRequestHeader('Accept', 'application/json');

    xhr.onload = function() {
      cacheLoading = false;
      try {
        var resp = JSON.parse(xhr.responseText);
        allProductsCache = resp.products || [];
      } catch(e) {
        allProductsCache = [];
      }
      var cbs = cacheCallbacks.slice();
      cacheCallbacks = [];
      cbs.forEach(function(cb) { cb(allProductsCache); });
    };

    xhr.onerror = function() {
      cacheLoading = false;
      allProductsCache = [];
      var cbs = cacheCallbacks.slice();
      cacheCallbacks = [];
      cbs.forEach(function(cb) { cb([]); });
    };

    xhr.send();
  }

  /* ——— Convert cached product format ——— */
  function normalizeCachedProduct(p) {
    return {
      id:              p.id,
      title:           p.title,
      handle:          p.handle,
      url:             '/products/' + p.handle,
      vendor:          p.vendor || '',
      price:           p.price || (p.variants && p.variants[0] ? p.variants[0].price : 0),
      compare_at_price: p.compare_at_price || null,
      featured_image:  p.images && p.images.length > 0
        ? { url: p.images[0].src, alt: p.images[0].alt || p.title }
        : null
    };
  }

  /* ——— Merge API + cache, deduplicate by ID ——— */
  function mergeProducts(apiProducts, cacheProducts) {
    var merged  = apiProducts.slice();
    var seenIds = {};
    apiProducts.forEach(function(p) { seenIds[p.id] = true; });

    cacheProducts.forEach(function(p) {
      var norm = normalizeCachedProduct(p);
      if (!seenIds[norm.id]) {
        seenIds[norm.id] = true;
        merged.push(norm);
      }
    });

    return merged;
  }

  /* ═══════════════════════════════════════════════════
     RENDER CARD — Matches sword-card.liquid exactly
     ═══════════════════════════════════════════════════ */
  function renderCard(p) {
    var imgSrc = p.featured_image ? p.featured_image.url : '';
    var imgAlt = p.featured_image ? p.featured_image.alt : p.title;
    var price  = p.price ? formatMoney(p.price) : '';
    var vendor = p.vendor || '';

    var imageHtml = imgSrc
      ? '<img src="' + imgSrc + '&width=400"' +
          ' srcset="' + imgSrc + '&width=200 200w,' + imgSrc + '&width=400 400w,' + imgSrc + '&width=600 600w"' +
          ' sizes="(max-width: 600px) 100vw, (max-width: 900px) 50vw, 25vw"' +
          ' alt="' + esc(imgAlt) + '" width="200" height="267" loading="lazy">'
      : '<svg width="92" height="210" viewBox="0 0 70 210" fill="none"><rect x="20" y="20" width="30" height="170" rx="2" fill="#3a3a3a" opacity="0.3"/><circle cx="35" cy="105" r="15" fill="#a8a8a8" opacity="0.2"/></svg>';

    return '' +
      '<div class="product-card" data-product-id="' + p.id + '" data-product-url="' + p.url + '">' +
        '<div class="card-media">' +
          '<div class="card-media-bg"></div>' +
          '<button class="wishlist-toggle card-wishlist" data-wishlist-handle="' + esc(p.handle) + '" aria-label="Add to Wishlist" type="button">' +
            '<svg class="wishlist-heart-icon" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5">' +
              '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/>' +
            '</svg>' +
          '</button>' +
          '<div class="card-svg-wrap">' + imageHtml + '</div>' +
          '<a href="' + p.url + '" class="card-quickview" data-quickview data-product-handle="' + esc(p.handle) + '">Quick View</a>' +
        '</div>' +
        '<div class="card-info">' +
          '<p class="card-category">' + esc(vendor) + '</p>' +
          '<h3 class="card-name">' + esc(p.title) + '</h3>' +
          '<div class="card-price-row">' +
            '<span class="card-price">From ' + price + '</span>' +
            '<div class="card-stars"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function renderProducts(products, container) {
    if (!container) return;
    container.innerHTML = products.map(renderCard).join('');
  }

  /* ═══════════════════════════════════════════════════
     RE-INIT WISHLIST AFTER RENDER
     ═══════════════════════════════════════════════════ */
  function reinitFeatures() {
    if (window.SmithsWishlist && typeof window.SmithsWishlist.has === 'function') {
      document.querySelectorAll('.wishlist-toggle').forEach(function(btn) {
        var handle = btn.getAttribute('data-wishlist-handle');
        if (!handle) return;
        if (window.SmithsWishlist.has(handle)) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-label', 'Remove from wishlist');
        } else {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-label', 'Add to wishlist');
        }
      });
    }
    applyRevealAnimation();
  }

  /* ═══════════════════════════════════════════════════
     CARD CLICK — Navigate to product page
     ═══════════════════════════════════════════════════ */
  function initCardClicks() {
    document.addEventListener('click', function(e) {
      var card = e.target.closest('.product-card');
      if (!card) return;
      if (!card.closest('#searchJsGrid, #searchCollectionGrid, #searchSuggestionsGrid, #searchLiquidResults')) return;

      if (e.target.closest('.wishlist-toggle') || e.target.closest('.card-wishlist')) return;
      if (e.target.closest('.card-quickview')) return;

      var productUrl = card.getAttribute('data-product-url');
      if (productUrl) window.location.href = productUrl;
    });
  }

  /* ═══════════════════════════════════════════════════
     QUICK VIEW EVENT DELEGATION
     ═══════════════════════════════════════════════════ */
  function initQuickViewDelegation() {
    document.addEventListener('click', function(e) {
      var qvLink = e.target.closest('[data-quickview]');
      if (!qvLink) return;
      if (!qvLink.closest('#searchJsGrid, #searchCollectionGrid, #searchSuggestionsGrid, #searchLiquidResults')) return;

      e.preventDefault();
      e.stopPropagation();

      var handle = qvLink.getAttribute('data-product-handle');
      if (handle && typeof window.openQuickView === 'function') {
        window.openQuickView(handle);
      } else {
        window.location.href = qvLink.getAttribute('href') || ('/products/' + handle);
      }
    });
  }

  /* ═══════════════════════════════════════════════════
     MAIN SEARCH
     Runs BOTH Predictive API and client-side filter,
     merges results so nothing is missed.
     ═══════════════════════════════════════════════════ */
  function doSearch(query) {
    if (!query || query.trim().length === 0) return;
    query = query.trim();

    hideAll();
    if (loadingWrap) loadingWrap.style.display = 'flex';
    if (currentXHR) { currentXHR.abort(); currentXHR = null; }

    var apiDone    = false;
    var cacheDone  = false;
    var apiResult  = { products: [], collections: [] };
    var cacheResult = [];

    function tryFinish() {
      if (!apiDone || !cacheDone) return;

      var mergedProducts = mergeProducts(apiResult.products, cacheResult);

      if (mergedProducts.length > 0) {
        hideAll();
        renderProducts(mergedProducts, jsGrid);
        jsCount.textContent = mergedProducts.length;
        jsCountLabel.textContent = mergedProducts.length === 1 ? 'result' : 'results';
        jsMeta.style.display = 'block';
        jsResults.style.display = 'block';
        reinitFeatures();
        return;
      }

      /* No products — try collection fallback */
      if (apiResult.collections.length > 0) {
        fetchCollectionProducts(apiResult.collections[0], query);
        return;
      }

      /* Nothing at all */
      showNoResults(query);
    }

    /* ——— SOURCE 1: Predictive API ——— */
    var params = [
      'q=' + encodeURIComponent(query),
      'resources[type]=product,collection',
      'resources[limit]=' + maxResults,
      'resources[options][unavailable_products]=last',
      'resources[options][fields]=title,product_type,variants.title,vendor,tag,body'
    ].join('&');

    var xhr = new XMLHttpRequest();
    currentXHR = xhr;
    xhr.open('GET', '/search/suggest.json?' + params, true);
    xhr.setRequestHeader('Accept', 'application/json');

    xhr.onload = function() {
      currentXHR = null;
      if (xhr.status >= 200 && xhr.status < 400) {
        try {
          var resp = JSON.parse(xhr.responseText);
          var results = resp.resources && resp.resources.results ? resp.resources.results : {};
          apiResult.products    = results.products    || [];
          apiResult.collections = results.collections || [];
        } catch(e) {}
      }
      apiDone = true;
      tryFinish();
    };

    xhr.onerror   = function() { currentXHR = null; apiDone = true; tryFinish(); };
    xhr.ontimeout = function() { currentXHR = null; apiDone = true; tryFinish(); };
    xhr.timeout   = 10000;
    xhr.send();

    /* ——— SOURCE 2: Client-side cache ——— */
    getAllProducts(function(products) {
      cacheResult = products.filter(function(p) {
        return productMatchesQuery(p, query);
      });
      cacheDone = true;
      tryFinish();
    });
  }

  /* ——— FETCH COLLECTION PRODUCTS ——— */
  function fetchCollectionProducts(collection, originalQuery) {
    var url = '/collections/' + collection.handle + '/products.json?limit=48';
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.setRequestHeader('Accept', 'application/json');

    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 400) {
        try {
          var resp = JSON.parse(xhr.responseText);
          var products = resp.products || [];
          if (products.length > 0) {
            hideAll();
            renderProducts(products.map(normalizeCachedProduct), collGrid);
            if (collName) collName.textContent = collection.title;
            collFallback.style.display = 'block';
            reinitFeatures();
          } else {
            showNoResults(originalQuery);
          }
        } catch(e) { showNoResults(originalQuery); }
      } else { showNoResults(originalQuery); }
    };

    xhr.onerror = function() { showNoResults(originalQuery); };
    xhr.send();
  }

  /* ——— NO RESULTS ——— */
  function showNoResults(query) {
    hideAll();
    if (emptyTerm) emptyTerm.textContent = query;
    if (emptyWrap) emptyWrap.style.display = 'flex';
    fetchSuggestions();
  }

  /* ——— SUGGESTIONS ——— */
  function fetchSuggestions() {
    var url = '/collections/all/products.json?limit=' + suggestionsCount;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 400) {
        try {
          var resp = JSON.parse(xhr.responseText);
          var products = resp.products || [];
          if (products.length > 0) {
            renderProducts(products.map(normalizeCachedProduct), suggestionsGrid);
            if (suggestionsWrap) suggestionsWrap.style.display = 'block';
            reinitFeatures();
          }
        } catch(e) {}
      }
    };
    xhr.send();
  }

  /* ——— ERROR ——— */
  function showError() {
    hideAll();
    if (errorWrap) errorWrap.style.display = 'flex';
  }

  /* ——— SCROLL REVEAL ——— */
  function applyRevealAnimation() {
    setTimeout(function() {
      var cards = document.querySelectorAll('#searchJsResults .product-card, #searchCollectionGrid .product-card, #searchSuggestionsGrid .product-card');
      cards.forEach(function(card) { card.classList.add('reveal'); });

      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function(entries) {
          entries.forEach(function(e) {
            if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
          });
        }, { threshold: 0.1 });
        cards.forEach(function(card) { obs.observe(card); });
      } else {
        cards.forEach(function(card) { card.classList.add('visible'); });
      }
    }, 50);
  }

  /* ——— SAVE RECENT ——— */
  function saveRecent(term) {
    if (!term || term.length < 2) return;
    try {
      var KEY = 'sb_recent_searches';
      var list = [];
      try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch(e) {}
      list = list.filter(function(t) { return t.toLowerCase() !== term.toLowerCase(); });
      list.unshift(term);
      if (list.length > 6) list = list.slice(0, 6);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch(e) {}
  }

  /* ——— INIT ——— */
  function init() {
    initCardClicks();
    initQuickViewDelegation();

    if (searchTerm && searchTerm.length > 0) {
      doSearch(searchTerm);
      saveRecent(searchTerm);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();